import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import type { BusinessLoansFormInput } from "web_myplann/Portfolio/Forms/BusinessLoansForm/businessLoansFormSchema";

export const BUSINESS_LOANS_FORM_DEFAULT_VALUES: BusinessLoansFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	signedAt: null,
	startAt: null,
	endAt: null,
	value: null,
	coDebtors: [],
	change: {
		originalObligationAmount: null,
		installment: null,
		interestRate: null,
		fixationEndDate: null,
		paymentFrequency: ClientPortfolioPaymentFrequencyEnum.Monthly,
	},
};
